const BREAKPOINTS = {
  sm: "450px",
  md: "768px",
  lg: "1024px",
};

export default BREAKPOINTS;
